/**
 * Plan-adaptation API client. Reuses the shared authenticated ``http``
 * axios instance from ``@/lib/api``.
 *
 * Reads power the Coach safety banner. Apply / reject are the athlete
 * confirmation path for Adaptive Coaching Loop V1 — they call the
 * existing deterministic backend and never invent a plan change.
 */
import { http } from "@/lib/api";

const ROOT = "/plan-adaptation";

/**
 * Fetch the currently-current adaptation decision for the signed-in
 * athlete. Returns ``null`` on 404 (no adaptation on record — most
 * athletes) so callers can render "no banner" without an error path.
 * Other errors are re-thrown so the caller can decide.
 */
export const fetchCurrentPlanAdaptation = async ({ signal, blockId } = {}) => {
  try {
    const res = await http.get(`${ROOT}/current`, {
      signal,
      params: blockId ? { block_id: blockId } : undefined,
    });
    return res.data;
  } catch (err) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
};

export const applyPlanAdaptation = async (adaptationId) => {
  const { data } = await http.post(
    `${ROOT}/${encodeURIComponent(adaptationId)}/apply`,
    {},
  );
  return data;
};

export const rejectPlanAdaptation = async (adaptationId, reason) => {
  const { data } = await http.post(
    `${ROOT}/${encodeURIComponent(adaptationId)}/reject`,
    reason ? { reason } : {},
  );
  return data;
};

export const _endpoints = { root: ROOT };
